import { Typography } from "@mui/material";
import { LineItem, calculateTotals, formatCurrency } from "../helpers/invoiceUtils";

interface Props {
  items: LineItem[];
}

export default function InvoiceTotals({ items }: Props) {
  const { subtotal, totalTax, total } = calculateTotals(items);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6, padding: "20px 0 4px" }}>
      <div style={{ display: "flex", gap: 24, alignItems: "baseline" }}>
        <Typography variant="body2" color="text.secondary">Subtotal:</Typography>
        <Typography variant="body2" fontWeight={600} fontFamily="monospace">{formatCurrency(subtotal)}</Typography>
      </div>
      <div style={{ display: "flex", gap: 24, alignItems: "baseline" }}>
        <Typography variant="body2" color="text.secondary">Impuestos:</Typography>
        <Typography variant="body2" fontWeight={600} fontFamily="monospace">{formatCurrency(totalTax)}</Typography>
      </div>
      <div style={{ display: "flex", gap: 24, alignItems: "baseline", marginTop: 4 }}>
        <Typography variant="body1" color="text.secondary">Total:</Typography>
        <Typography variant="body1" fontWeight={700} fontFamily="monospace" color="primary.main">{formatCurrency(total)}</Typography>
      </div>
    </div>
  );
}
